module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusive-01-d0300bfcb21f75020fc8a0a1a13349f5.png";